<app-navigation-header title="Roles" i18n-title="@@roles-rolesTitle">
	<app-company-roles-table
		[appBreadcrumbLabel]="rolesTableBreadcrumbLabel"
		[roleDataRequest]="getMyRoles"
		(roleSelected)="onRoleSelected($event)"
	>
	</app-company-roles-table>
</app-navigation-header>
